/**
 * A vocabulary level inside the merged character + word curriculum. It follows the character level
 * that introduces the last character any of its words needs, so it reads as `11-W14` when it is the
 * 14th word level overall and sits after character level 11.
 */
export interface WordLevel {
  /** Zero-based index of the character level this word level directly follows. */
  characterLevelIndex: number;
  /** Zero-based position among the script's word levels, in curriculum order. */
  index: number;
  requiredCharacters: string[];
  /** One-based position among the word levels that follow the same character level. */
  sublevel: number;
  words: string[];
}

/**
 * The curriculum label: the 14th word level overall, following character Level 11, is `11-W14`.
 * The W number counts every word level in curriculum order, not only those after the same `#`.
 */
export function formatWordLevelLabel(
  level: Pick<WordLevel, "characterLevelIndex" | "index">,
): string {
  return `${level.characterLevelIndex + 1}-W${level.index + 1}`;
}
